<div class="py-4 position-relative">
    <span class="footnote">status</span>
    <h2 class="py-2 font-weight-bold text-capitalize">{{userStatus}}</h2>
    <div><span class="text-large font-weight-bold">{{activitiesCount}}</span> Activities completed</div>
    <img *ngIf="userStatus" src="https://equityisdynamic-static.s3.amazonaws.com/dashboard/status/{{userStatus | lowercase }}.png"
        class="img-fluid journey-status-icon position-absolute">
</div>